import { useNavigate } from 'react-router-dom'
import posthog from 'posthog-js'
import CashIcon from 'assets/images/funds/cashbox_4.png'
import {
    cashboxStateChip,
    cashboxStateLabel,
} from 'utilities/helper/cashBoxes'
import { faPlain, fundName } from 'utilities/helper/format'
import {
    Amount,
    Chip,
    FundCard,
    FundCardHeader,
    FundRow,
    FundSection,
    StatusLine,
} from '../../card'

interface IItemProps {
    item: ICashBoxes
}

export default function Item({ item }: IItemProps) {
    const navigate = useNavigate()
    // Colours moved to the shared helper alongside the labels: the local map
    // painted `act` (فعال) the same grey as `dft`, matching a label map that
    // also called both «پیش نویس».
    const chipStyle = cashboxStateChip(item.state)
    return (
        <FundCard
            onClick={() => {
                // Mirrors `fund_list_item_clicked` on the moneypool card, so
                // the two halves of the صندوق‌ها tab can be compared at all.
                // Deliberately without the name the twin used to send: a box
                // name is free text the manager typed and often carries a
                // family or workplace name — PostHog is the wrong place for
                // it, and `state` is what the funnel actually needs.
                posthog.capture('cashbox_list_item_clicked', {
                    cashbox_id: item.id,
                    state: item.state,
                })
                navigate(`/cashbox/${item.id}`)
            }}
        >
            <FundCardHeader
                avatar={CashIcon}
                title={fundName(item.name)}
                subtitle={`${faPlain.format(
                    item.period.valid_memberships_count
                )} عضو · قرعه‌کشی`}
            />

            <FundSection>
                <div className="flex flex-col gap-2">
                    <FundRow
                        label="ارزش هر سهم"
                        strong
                        value={<Amount value={item.period.share_value} />}
                    />
                    <FundRow
                        label="سهم‌های فعلی"
                        value={`${faPlain.format(
                            Number(item.period.total_shares)
                        )} سهم`}
                    />
                    <FundRow
                        label="تعداد وام"
                        value={`${faPlain.format(
                            Number(item.period.number_of_loans)
                        )} وام`}
                    />
                    <FundRow
                        label="تاریخ قرعه‌کشی"
                        value={`${faPlain.format(
                            Number(item.period.day_of_draw)
                        )}ام هر ماه`}
                    />
                </div>
            </FundSection>

            <FundSection>
                <p className="text-sm text-text-secondary">وضعیت</p>
                <div className="mt-2">
                    <StatusLine label="حالت صندوق">
                        <Chip
                            bg={chipStyle.bgColor}
                            color={chipStyle.color}
                            label={cashboxStateLabel(item.state, item.period)}
                        />
                    </StatusLine>
                </div>
            </FundSection>
        </FundCard>
    )
}
